"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _hoisted_1 = {
    id: "Question",
    class: "container"
};
const _hoisted_2 = { class: "QuestionWrapper container" };
const _hoisted_3 = { class: "QuestionTitleWrapper" };
const _hoisted_4 = { class: "QuestionTitle" };
const _hoisted_5 = { class: "QuestionOptionInnerWrapper" };
const _hoisted_6 = { class: "thumbnail" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = { class: "QuestionOptionTextWrapper" };
const _hoisted_10 = { class: "QuestionOptionText" };
const _hoisted_11 = { class: "panel-footer ProgressBarFooter" };
const _hoisted_12 = { class: "progress" };
const _hoisted_13 = ["aria-valuenow", "aria-valuemax"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_WorldMap = (0, vue_1.resolveComponent)("WorldMap");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createElementVNode)("div", _hoisted_3, [
                (0, vue_1.createElementVNode)("h3", _hoisted_4, (0, vue_1.toDisplayString)(_ctx.question.title), 1 /* TEXT */)
            ]),
            (_ctx.questionNumber === 0)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_WorldMap, {
                    key: 0,
                    onCountrySelected: _ctx.countrySelected
                }, null, 8 /* PROPS */, ["onCountrySelected"]))
                : (0, vue_1.createCommentVNode)("v-if", true),
            (_ctx.question.options.length)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    key: _ctx.question.type,
                    class: "QuestionOptionOuterWrapper"
                }, [
                    (0, vue_1.createElementVNode)("div", _hoisted_5, [
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.question.options, (option) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: option.id,
                                class: (0, vue_1.normalizeClass)(["QuestionOption", _ctx.questionOptionClass])
                            }, [
                                (0, vue_1.createElementVNode)("div", _hoisted_6, [
                                    (0, vue_1.createElementVNode)("button", {
                                        class: "QuestionOptionButton",
                                        "data-name": "quiz",
                                        onClick: ($event) => (_ctx.answerQuestion(option.id))
                                    }, [
                                        (0, vue_1.createElementVNode)("img", {
                                            class: "QuestionOptionImage",
                                            src: `//monet-prtl-co.imgix.net/Shared/CountryTest/${_ctx.question.type}/${option.id}.jpg`,
                                            alt: option.label
                                        }, null, 8 /* PROPS */, _hoisted_8),
                                        (0, vue_1.createElementVNode)("span", _hoisted_9, [
                                            (0, vue_1.createElementVNode)("span", _hoisted_10, (0, vue_1.toDisplayString)(option.label), 1 /* TEXT */)
                                        ])
                                    ], 8 /* PROPS */, _hoisted_7)
                                ])
                            ], 2 /* CLASS */));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ]))
                : (0, vue_1.createCommentVNode)("v-if", true)
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_11, [
            (0, vue_1.createElementVNode)("div", _hoisted_12, [
                (0, vue_1.createElementVNode)("div", {
                    id: "t_progress",
                    class: "progress-bar",
                    role: "progressbar",
                    "aria-valuenow": _ctx.questionNumber + 1,
                    "aria-valuemin": "0",
                    "aria-valuemax": _ctx.questionTotal,
                    style: (0, vue_1.normalizeStyle)(`
						min-width: 1rem; width: ${_ctx.progress}%
					`)
                }, null, 12 /* STYLE, PROPS */, _hoisted_13)
            ])
        ])
    ]));
}
exports.render = render;
